import { useChatPage } from "../-hooks/useChatPage";
import type { ChatThreadActions } from "./chatThreadActions";

export type { ChatThreadActions } from "./chatThreadActions";

export function useChatThreadActions(): ChatThreadActions {
    return useChatPage().threadActions;
}
